import { Component } from "react";
import "./InputTextElement.css";
import "./../common.css";

const LENGTH_FOR_WARNING = 100;

export default class InputTextElement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      touched: false,
      focused: false,
      charactersLeft: LENGTH_FOR_WARNING + 1, // in case we don't need to check max length, we need something longer than LENGTH_FOR_WARNING
    };

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.isInvalid = this.isInvalid.bind(this);
  }

  onChange(evt) {
    const value = evt.target.value;
    if (this.props.maxLength) {
      this.setState({ charactersLeft: this.props.maxLength - value.length });
    }
    this.props.onChange && this.props.onChange(evt);
  }

  onFocus(event) {
    this.setState({ focused: true });
    this.props.onFocus && this.props.onFocus(event);
  }

  onBlur(event) {
    this.setState({ touched: true, focused: false });
    this.props.onBlur && this.props.onBlur(event);
  }

  emptyField(value) {
    return !value && value.length === 0;
  }

  isInvalid() {
    return (
      this.emptyField(this.props.value) &&
      (this.state.touched || this.props.formSubmitted)
    );
  }

  focus() {
    this.element && this.element.focus && this.element.focus();
  }

  clearState = () => {
    this.setState({
      touched: false,
      focused: false,
      charactersLeft: LENGTH_FOR_WARNING + 1, // in case we don't need to check max length, we need something longer than LENGTH_FOR_WARNING
    });
  };

  render() {
    let additionalClass = "";
    let showTooltip = false;
    let tooltipText = "";
    if (this.props.required && this.isInvalid()) {
      additionalClass += " required";
      showTooltip = true;
      tooltipText = "* Required field";
    } else if (this.state.charactersLeft <= LENGTH_FOR_WARNING && this.state.focused) {
      showTooltip = true;
      if (this.state.charactersLeft > 0) {
        additionalClass += " length-warning";
        tooltipText = this.state.charactersLeft + " characters left";
      } else {
        additionalClass += " length-error";
        tooltipText = "Field length reached";
      }
    }

    let additionalProps = {};
    if (this.props.maxLength) {
      additionalProps.maxLength = this.props.maxLength;
    }

    const TagName = this.props.tagName;
    const props = Object.assign({}, this.props, additionalProps);
    props.onChange = this.onChange;
    props.onFocus = this.onFocus;
    props.onBlur = this.onBlur;
    props.className =
      (props.className ? props.className + " " : "") +
      "talaera-" +
      this.props.tagName +
      additionalClass;

    if (props.rtl) {
      props.dir = "rtl";
    }
    if (props.dataCy) {
      props["data-cy"] = props.dataCy;
      delete props.dataCy;
    }
    delete props.rtl;
    delete props.tagName;
    delete props.formSubmitted;

    return (
      <div className="input-container">
        <TagName {...props} ref={c => (this.element = c)} />
        {showTooltip && (
          <span className={"input-tooltip" + additionalClass}>{tooltipText}</span>
        )}
      </div>
    );
  }
}
